/**
 * /smartlinks/autorank — SmartLink auto-rank operator page.
 *
 * Declares a TanStack Router route and renders the
 * `SmartlinkAutorankPage`. The page auto-registers against the scaffolded
 * `rootRoute` once the root wire-up cycle appends it to `router.tsx`.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { SmartlinkAutorankPage } from "@/features/smartlinks-autorank/SmartlinkAutorankPage";

// ---------------------------------------------------------------------------
// Route — mounts at `/smartlinks/autorank`.
// `validateSearch` reserves room for an `?offerId=` deep-link so operators
// can jump from an offer detail page into the stats table prefilled.
// ---------------------------------------------------------------------------

interface SmartlinkAutorankSearch {
	offerId?: string;
}

export const smartlinksAutorankRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/smartlinks/autorank",
	validateSearch: (raw: Record<string, unknown>): SmartlinkAutorankSearch => {
		const offerId = raw.offerId;
		if (typeof offerId === "string" && offerId.trim().length > 0) {
			return { offerId: offerId.trim() };
		}
		return {};
	},
	component: SmartlinksAutorankRoute,
});

export default smartlinksAutorankRoute;

// ---------------------------------------------------------------------------
// Thin wrapper so the TanStack route can read the typed search params and
// pass them through as props. Kept as a named export for tree-shaking.
// ---------------------------------------------------------------------------

export function SmartlinksAutorankRoute() {
	const { offerId } = smartlinksAutorankRoute.useSearch();
	return <SmartlinkAutorankPage initialOfferId={offerId} />;
}
